import { Component, inject, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonThemes, ButtonSizes, ButtonComponent } from '../button/button.component';
import { CommonModule } from '@angular/common';
import { environment } from '@environments/environment';
import { CustomerAddressPayload } from '@shared/models/customer-address/customer-address.model';
import { CustomerAddressService } from '@shared/services/customer-address/customer-address.service';
import { SelectComponent } from '../select/select.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CustomerStore } from '@shared/stores/customer/customer.store';
import { UserStore } from '@shared/stores/user/user.store';
import { Customer } from '@shared/models/customer/customer.model';
import { User } from '@shared/models/user/user.model';
import { CustomerService } from '@shared/services/customer/customer.service';
import { ToastService } from '@shared/services/toast/toast.service';
import { ERR_MESSAGES } from '@shared/constants/messages.constants';
import { TOAST_TYPE } from '@shared/constants/toast.constants';

@Component({
  selector: 'avenir-order-request-response-modal',
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    SelectComponent,
    ReactiveFormsModule
  ],
  templateUrl: './order-request-response-modal.component.html',
  styleUrl: './order-request-response-modal.component.scss'
})
export class OrderRequestResponseModalComponent {
  readonly BUTTON_THEME = ButtonThemes;
  readonly BUTTON_SIZE = ButtonSizes;
  @Input() userName: string = '';
  @Input() accountName: string = '';
  @Input() accountNumber: string = '';
  @Input() location: string = '';
  @Input() currentTankLevel: number = 0;
  @Input() deliveryInstructions: string = '-';
  public modalService = inject(NgbModal);

  btnCloseLabel = $localize`:@@close:Close`

}
